<template>
    <div ref="target">
        <apexchart :type="options.chart.type" :height="options.chart.height" :width="options.chart.width" :options="options" :series="series"></apexchart>
    </div>
</template>

<script setup lang="ts">
import {PropType, ref, Ref, watch} from 'vue';
import {ApexOptionsWrapped} from "@/helper/apexchart";
import {useInViewport} from '@/helper/useInViewport';

// props
const props = defineProps({
    options: {
        type: Object as  PropType<ApexOptionsWrapped>,
        required: true,
    },
    viewportWatcher: {
        type: Boolean,
        default: true,
    }
});

const series : Ref<ApexAxisChartSeries|ApexNonAxisChartSeries>= ref(props.viewportWatcher ? [] : props.options.series);

const {target, isInViewport} = useInViewport({
    threshold: 0.1,
    once: true
})
if (props.viewportWatcher) {
    watch(isInViewport, (v) => {
        series.value = props.options.series
    })
}

</script>

